module.exports = __webpack_public_path__ + "media/images/partners/nezavisimaya_ocenka2025-a58f39965f49a6b1366674c41add225b.svg";